import React, { useEffect, useState } from 'react'
import styles from './ForkScreen.module.css'
import { useLocation, useNavigate } from "react-router-dom";
import useOnboardingTracker from '../../hooks/useOnboardingTracker';
import decodeToken from '../../lib/decodeToken';
import { listAgents, countAgentsbyUserId, fetchTeamDashboard } from '../../Store/apiStore';

const ForkScreen = () => {
    const navigate = useNavigate();
    const { steps, trackStep } = useOnboardingTracker();
    const location = useLocation();
    // const [agentCount, setAgentCount] = useState()
    const mode = location?.state?.mode;
    const token = localStorage.getItem("token");

    /*
     * Existing-agent escape hatch.
     *
     * Bug history: users with 2+ agents got stuck on this screen.
     *   /fast-agent-detail → no SelectAgentId → /fork → user has no
     *   "pick existing" affordance → either creates a 3rd agent or
     *   refreshes and the loop continues.
     *
     * Fix: on mount, count this user's agents. If they already have
     * one or more, send them to /dashboard (multi-agent picker) so
     * they can choose which one to open. Only users with ZERO agents
     * see the fork's create-new flow.
     *
     * `mode === "new"` is the explicit "I want to create another
     * agent" intent (set by Dashboard's "Add Agent" button), so we
     * SKIP the redirect in that case and let the user proceed.
     */
    useEffect(() => {
        if (mode === "new") return;
        const userId = decodeToken(token)?.id;
        if (!userId) return;
        // Team members can access agents across several owners. Count the
        // AGGREGATE accessible set (own + every owner they belong to), not just
        // their own — otherwise an admin who just deleted their own agent lands
        // here with own-count 0 and gets stuck on the create screen even though
        // owner agents are still available.
        const isTeamMember = !!localStorage.getItem("teamOwnerId");
        let cancelled = false;
        (async () => {
            try {
                const count = isTeamMember
                    ? (await fetchTeamDashboard())?.agents?.length || 0
                    : await countAgentsbyUserId(userId);
                if (cancelled) return;
                if (count >= 1) {
                    navigate("/dashboard", { replace: true });
                }
            } catch (err) {
                console.warn(
                    "[ForkScreen] agent count check failed:",
                    err?.message || err,
                );
            }
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, mode]);
    const handleFastSetup = () => {
        const token = localStorage.getItem("token");
        const email = sessionStorage.getItem("jobberIntegrationEmail") || localStorage.getItem("userEmail");

        trackStep({
            stepName: "setup_method_selected",
            screenName: "Fork Screen",
            email: email,
            userId: decodeToken(token)?.id || null,
            data: {
                agent_creation_method: "fast_setup"
            },
        });
        if (mode == "new") {

            navigate('/business-step', {
                state: { mode: "new" }
            });
        }
        else {
            navigate('/business-step');
        }

    };

    const handleGuidedSetup = () => {
        sessionStorage.clear();
        const token = localStorage.getItem("token");
        const email = sessionStorage.getItem("jobberIntegrationEmail") || localStorage.getItem("userEmail");

        trackStep({
            stepName: "setup_method_selected",
            screenName: "Fork Screen",
            email: email,
            userId: decodeToken(token)?.id || null,
            data: {
                agent_creation_method: "guided_setup"
            },
        });

        navigate('/steps');
    };
    // useEffect(() => {
    //     const isAgentCreated = sessionStorage.getItem("isAgentCreated");

    //     if (isAgentCreated === "true") {
    //         navigate("/fast-agent-detail", { replace: true });
    //     }
    // }, [navigate])
    useEffect(() => {
        const isAgentCreated = sessionStorage.getItem("isAgentCreated");

        if (isAgentCreated === "true") {
            sessionStorage.removeItem("isAgentCreated");

            // 1️⃣ Current history ko overwrite karo
            window.history.replaceState(null, "", "/fast-agent-detail");

            // 2️⃣ React router se navigate karo
            navigate("/fast-agent-detail", { replace: true });
        }
    }, [navigate]);
    // const fetchAgentCountFromUser = async () => {
    //     try {
    //         const response = await listAgents()
    //         const filterAgents = await response.filter(res => res.userId === decodeToken(token)?.id || null)
    //         setAgentCount(filterAgents.length)
    //         // console.log(userId, "userid", filterAgents.length)

    //     } catch (error) {
    //         console.log(error)
    //         setAgentCount(0)
    //     }
    // }
    // useEffect(() => {
    //     fetchAgentCountFromUser()
    // }, [])
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.titleBar}>
                    <h4 className={styles.lightTitle}>Set Up Your</h4>
                    <h5 className={styles.boldTitle}>AI Receptionist</h5>
                    <p className={styles.subtitle}>Simple. Neutral. No pressure.</p>
                    <p className={styles.description}>Choose how you’d like to <span className={styles.boldText}>get started. </span> <br />You can change everything later.</p>
                </div>
                <div className={styles.SetUpDiv}>
                    <div className={styles.FastSetup} onClick={handleFastSetup}>
                        <div className={styles.iconFast}>
                            <img src='/svg/fast_setup_icon.svg' alt='fast_setup_icon' />
                        </div>
                        <div className={styles.textDiv}>
                            <p className={styles.fast}>FAST SETUP <span className={styles.Threemint}>(3 minutes)</span></p>
                            <p className={styles.badge}>Recommended for first-time users</p>
                        </div>
                        <div className={styles.iconFast}>
                            <img src='/svg/setup_arrow_icon.svg' alt='setup_arrow_icon' />
                        </div>
                    </div>
                    <p className={styles.setUpDecs}>Get your AI receptionist live quickly using smart defaults. You can fine-tune details anytime.</p>
                    {/* {agentCount == 0 ? "" : <div className={styles.divider}></div>} */}

                </div>
                {/* {agentCount == 0 ? "" : <div className={styles.GuidSetUpDiv} onClick={handleGuidedSetup} >
                    <p className={styles.guide}>Guided Setup <span><img src='/svg/guided_icon.svg' alt='guided_icon' /></span></p>
                    <p className={styles.guideDesc}>Customize every detail for maximum accuracy.</p>
                </div>} */}

                <div className={styles.notSure}>
                    <p>Not sure yet? <br />Start fast and refine later -  nothing is locked.</p>
                </div>


            </div>
            <div className={styles.StartMain}>
                <div className={styles.floatingDiv}>
                    {Array.from({ length: 5 }, (_, i) => (
                        <img key={i} src={`images/Ellipse ${i + 1}.png`} alt={`Ellipse ${i + 1}`} />
                    ))}
                </div>
            </div>

        </div>
    )
}

export default ForkScreen
